export const ADDRESS_LIST_SOURCE = {
    ADDRESS_LIST: "address-list",
    ADDRESS_LIST_V2: "address-list-v2",
    ADDRESS_LIST_ERROR_HALF_CARD: "address-list-error-half-card",
    ADDRESS_LIST_FOOTER: "address-list-footer",
    NEW_LOCATION_FOOTER: "new-location-footer",
};

export const LOCATION_NOT_FOUND = {
    IMAGE: "portal/static-assets/images/cart/errors/address/location_not_found.png",
    HEIGHT: 180,
    WIDTH: 360,
};

export const ADD_ADDRESS_CONFIGS = {
    TITLE: "Add or select delivery address to proceed",
    CTA: "Add or select address",
    CLOSE_ICON: {
        color: "#F0F0F5",
        fill: "#616469",
        size: 28,
    },
};
